import "./card_holder.css";
export function CardHolder(props) {
    let className = "";
    if(props.className !== undefined){
        className = props.className;
    }
    return (<div className={'card_holder '+className}>
        {props.children}
    </div>);;
}